import React, { useMemo, useReducer } from 'react';

import { SignUp } from './authenticatorComponents/SignUp';
import { LogIn } from './authenticatorComponents/LogIn';
import { AuthenticatorContext } from './authenticatorComponents/AuthenticatorContext';
import { ConfirmSignUp } from './authenticatorComponents/ConfirmSignUp';
import { ForgotPassword } from './authenticatorComponents/ForgotPassword';
import { SetNewPassword } from './authenticatorComponents/SetNewPassword';

const authenticatorReducer = (state, action) => {
   switch (action.type) {
      case 'submitForm': {
         return {
            ...state,
            formSubmitting: true,
            errorMessage: null,
            successMessage: null,
         };
      }
      case 'submitComplete': {
         return {
            ...state,
            formSubmitting: false,
         };
      }
      case 'setMessage': {
         return {
            ...state,
            successMessage: action.successMessage || null,
            errorMessage: action.errorMessage || null,
            formSubmitting: false,
         };
      }
      case 'clearMessage': {
         return {
            ...state,
            successMessage: null,
            errorMessage: null,
         };
      }
      case 'changeView': {
         return {
            ...state,
            currentView: action.view,
            errorMessage: null,
            successMessage: action.successMessage || null,
            formSubmitting: false,
            userData: action.userData || state.userData,
         };
      }
      default: {
         return state;
      }
   }
};

const Authenticator = ({ initialView }) => {
   const [state, dispatch] = useReducer(authenticatorReducer, {
      currentView: initialView,
      formSubmitting: false,
      errorMessage: null,
      successMessage: null,
      userData: {},
   });

   const authenticatorValue = useMemo(
      () => ({ state, dispatch }),
      [state, dispatch]
   );

   return (
      <div>
         <AuthenticatorContext.Provider value={authenticatorValue}>
            {state.currentView === 'logIn' && <LogIn />}
            {state.currentView === 'signUp' && <SignUp />}
            {state.currentView === 'confirmSignUp' && <ConfirmSignUp />}
            {state.currentView === 'forgotPassword' && <ForgotPassword />}
            {state.currentView === 'setNewPassword' && <SetNewPassword />}
         </AuthenticatorContext.Provider>
      </div>
   );
};

Authenticator.defaultProps = { initialView: 'logIn' };

export { Authenticator };
